import _typeof from "@babel/runtime/helpers/typeof";
import n from "lodash/uniq";
import t from "lodash/uniqBy";
import r from "lodash/sortBy";
import e from "lodash/last";
import a from "lodash/isDate";
import { utcParse as i, timeParse as o } from "d3-time-format";
import { scaleLinear as u, scalePoint as c, scaleBand as f, scaleUtc as d, scaleTime as s, scaleLog as l, scaleSymlog as m } from "d3-scale";
import { timeInterval as v, timeMillisecond as y, utcMillisecond as p, timeSecond as h, utcSecond as g, timeMinute as x, utcMinute as k, timeHour as T, utcHour as M, timeWeek as w, utcWeek as b, timeSunday as E, utcSunday as S, timeMonday as D, utcMonday as C, timeTuesday as U, utcTuesday as j, timeWednesday as O, utcWednesday as R, timeThursday as H, utcThursday as V, timeFriday as q, utcFriday as A, timeSaturday as B, utcSaturday as F, timeMonth as N, utcMonth as z, timeYear as I, utcYear as P } from "d3-time";

function $() {
  return $ = Object.assign || function (n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var e in r) {
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
      }
    }

    return n;
  }, $.apply(this, arguments);
}

var G = ["millisecond", "second", "minute", "hour", "day", "month", "year"],
    J = [function (n) {
  return n.setMilliseconds(0);
}, function (n) {
  return n.setSeconds(0);
}, function (n) {
  return n.setMinutes(0);
}, function (n) {
  return n.setHours(0);
}, function (n) {
  return n.setDate(1);
}, function (n) {
  return n.setMonth(0);
}],
    K = {
  millisecond: [],
  second: J.slice(0, 1),
  minute: J.slice(0, 2),
  hour: J.slice(0, 3),
  day: J.slice(0, 4),
  month: J.slice(0, 5),
  year: J.slice(0, 6)
},
    L = function L(n) {
  return function (t) {
    return K[n].forEach(function (n) {
      n(t);
    }), t;
  };
},
    Q = function Q(n) {
  var t = n.format,
      r = void 0 === t ? "native" : t,
      e = n.precision,
      a = void 0 === e ? "millisecond" : e,
      u = n.useUTC,
      c = void 0 === u || u,
      f = L(a);
  return function (n) {
    if (void 0 === n) return n;
    if ("native" === r || n instanceof Date) return f(n);
    var t = c ? i(r) : o(r);
    return f(t(n));
  };
},
    W = function W(n, t, r, e) {
  var a,
      i,
      o,
      c,
      f = n.min,
      d = void 0 === f ? 0 : f,
      s = n.max,
      l = void 0 === s ? "auto" : s,
      m = n.stacked,
      v = void 0 !== m && m,
      y = n.reverse,
      p = void 0 !== y && y,
      h = n.clamp,
      g = void 0 !== h && h,
      x = n.nice,
      k = void 0 !== x && x;
  "auto" === d ? a = !0 === v ? null != (i = t.minStacked) ? i : 0 : t.min : a = d;
  "auto" === l ? o = !0 === v ? null != (c = t.maxStacked) ? c : 0 : t.max : o = l;
  var T = u().rangeRound("x" === e ? [0, r] : [r, 0]).domain(p ? [o, a] : [a, o]).clamp(g);
  return !0 === k ? T.nice() : "number" == typeof k && T.nice(k), X(T, v);
},
    X = function X(n, t) {
  void 0 === t && (t = !1);
  var r = n;
  return r.type = "linear", r.stacked = t, r;
},
    Y = function Y(n, t, r) {
  var e = c().range([0, r]).domain(t.all);
  return e.type = "point", e;
},
    Z = function Z(n) {
  var t = n;
  return t.type = "point", t;
},
    _ = function _(n, t, r, e) {
  var a = n.round,
      i = void 0 === a || a,
      o = f().range("x" === e ? [0, r] : [r, 0]).domain(t.all).round(i);
  return nn(o);
},
    nn = function nn(n) {
  var t = n;
  return t.type = "band", t;
},
    tn = function tn(n, t, r) {
  var e,
      a,
      i = n.format,
      o = void 0 === i ? "native" : i,
      u = n.precision,
      c = void 0 === u ? "millisecond" : u,
      f = n.min,
      l = void 0 === f ? "auto" : f,
      m = n.max,
      v = void 0 === m ? "auto" : m,
      y = n.useUTC,
      p = void 0 === y || y,
      h = n.nice,
      g = void 0 !== h && h,
      x = Q({
    format: o,
    precision: c,
    useUTC: p
  });
  e = "auto" === l ? x(t.min) : "native" !== o ? x(l) : l, a = "auto" === v ? x(t.max) : "native" !== o ? x(v) : v;
  var k = p ? d() : s();
  k.range([0, r]), e && a && k.domain([e, a]), !0 === g ? k.nice() : "object" != _typeof(g) && "number" != typeof g || k.nice(g);
  var T = k;
  return T.type = "time", T.useUTC = p, T;
},
    rn = function rn(n, t, r, e) {
  var a,
      i = n.base,
      o = void 0 === i ? 10 : i,
      u = n.min,
      c = void 0 === u ? "auto" : u,
      f = n.max,
      d = void 0 === f ? "auto" : f;
  if (t.all.some(function (n) {
    return 0 === n;
  })) throw new Error("a log scale domain must not include or cross zero");
  var s,
      m,
      v = !1;
  if (t.all.filter(function (n) {
    return null != n;
  }).forEach(function (n) {
    v || (void 0 === a ? a = Math.sign(n) : Math.sign(n) !== a && (v = !0));
  }), v) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
  s = "auto" === c ? t.min : c, m = "auto" === d ? t.max : d;
  var y = l().domain([s, m]).rangeRound("x" === e ? [0, r] : [r, 0]).base(o).nice();
  return y.type = "log", y;
},
    en = function en(n, t, r, e) {
  var a,
      i,
      o = n.constant,
      u = void 0 === o ? 1 : o,
      c = n.min,
      f = void 0 === c ? "auto" : c,
      d = n.max,
      s = void 0 === d ? "auto" : d,
      l = n.reverse,
      v = void 0 !== l && l;
  a = "auto" === f ? t.min : f, i = "auto" === s ? t.max : s;
  var y = m().constant(u).rangeRound("x" === e ? [0, r] : [r, 0]).nice();
  !0 === v ? y.domain([i, a]) : y.domain([a, i]);
  var p = y;
  return p.type = "symlog", p;
},
    an = function an(n) {
  return "x" === n ? "y" : "x";
},
    on = function on(n, t) {
  return n === t;
},
    un = function un(n, t) {
  return n.getTime() === t.getTime();
};

function cn(n, t, r, e) {
  switch (n.type) {
    case "linear":
      return W(n, t, r, e);

    case "point":
      return Y(0, t, r);

    case "band":
      return _(n, t, r, e);

    case "time":
      return tn(n, t, r);

    case "log":
      return rn(n, t, r, e);

    case "symlog":
      return en(n, t, r, e);

    default:
      throw new Error("invalid scale spec");
  }
}

var fn = function fn(n, t, r) {
  var e;

  if ("stacked" in r && r.stacked) {
    var a = n.data["x" === t ? "xStacked" : "yStacked"];
    return null == a ? null : r(a);
  }

  return null != (e = r(n.data[t])) ? e : null;
},
    dn = function dn(n, t, r, e, a) {
  var i = n.map(function (n) {
    return function (n) {
      return $({}, n, {
        data: n.data.map(function (n) {
          return {
            data: $({}, n)
          };
        })
      });
    }(n);
  }),
      o = sn(i, t, r);
  "stacked" in t && !0 === t.stacked && vn(o, i), "stacked" in r && !0 === r.stacked && yn(o, i);
  var u = cn(t, o.x, e, "x"),
      c = cn(r, o.y, a, "y"),
      f = i.map(function (n) {
    return $({}, n, {
      data: n.data.map(function (n) {
        return $({}, n, {
          position: {
            x: fn(n, "x", u),
            y: fn(n, "y", c)
          }
        });
      })
    });
  });
  return $({}, o, {
    series: f,
    xScale: u,
    yScale: c
  });
},
    sn = function sn(n, t, r) {
  return {
    x: ln(n, "x", t),
    y: ln(n, "y", r)
  };
},
    ln = function ln(a, i, o, u) {
  var c = void 0 === u ? {} : u,
      f = c.getValue,
      d = void 0 === f ? function (n) {
    return n.data[i];
  } : f,
      s = c.setValue,
      l = void 0 === s ? function (n, t) {
    n.data[i] = t;
  } : s;
  if ("linear" === o.type) a.forEach(function (n) {
    n.data.forEach(function (n) {
      var t = d(n);
      t && l(n, parseFloat(String(t)));
    });
  });else if ("time" === o.type && "native" !== o.format) {
    var m = Q(o);
    a.forEach(function (n) {
      n.data.forEach(function (n) {
        var t = d(n);
        t && l(n, m(t));
      });
    });
  }
  var v = [];

  switch (a.forEach(function (n) {
    n.data.forEach(function (n) {
      v.push(d(n));
    });
  }), o.type) {
    case "linear":
      var y = r(n(v).filter(function (n) {
        return null !== n;
      }), function (n) {
        return n;
      });
      return {
        all: y,
        min: Math.min.apply(Math, y),
        max: Math.max.apply(Math, y)
      };

    case "time":
      var p = t(v, function (n) {
        return n.getTime();
      }).slice(0).sort(function (n, t) {
        return t.getTime() - n.getTime();
      }).reverse();
      return {
        all: p,
        min: p[0],
        max: e(p)
      };

    default:
      var h = n(v);
      return {
        all: h,
        min: h[0],
        max: e(h)
      };
  }
},
    mn = function mn(n, t, r) {
  var i = an(n),
      o = [];
  t[i].all.forEach(function (t) {
    var u = a(t) ? un : on,
        c = [];
    r.forEach(function (r) {
      var a = r.data.find(function (n) {
        return u(n.data[i], t);
      }),
          f = null,
          d = null;

      if (void 0 !== a) {
        if (null !== (f = a.data[n])) {
          var s = e(c);
          void 0 === s ? d = f : null !== s && (d = s + f);
        }

        a.data["x" === n ? "xStacked" : "yStacked"] = d;
      }

      c.push(d), null !== d && o.push(d);
    });
  }), t[n].minStacked = Math.min.apply(Math, o), t[n].maxStacked = Math.max.apply(Math, o);
},
    vn = function vn(n, t) {
  return mn("x", n, t);
},
    yn = function yn(n, t) {
  return mn("y", n, t);
},
    pn = function pn(n) {
  var t = n.bandwidth();
  if (0 === t) return n;
  var r = t / 2;
  return n.round() && (r = Math.round(r)), function (t) {
    var e;
    return (null != (e = n(t)) ? e : 0) + r;
  };
},
    hn = {
  millisecond: [y, p],
  second: [h, g],
  minute: [x, k],
  hour: [T, M],
  day: [v(function (n) {
    return n.setHours(0, 0, 0, 0);
  }, function (n, t) {
    return n.setDate(n.getDate() + t);
  }, function (n, t) {
    return (t.getTime() - n.getTime()) / 864e5;
  }, function (n) {
    return Math.floor(n.getTime() / 864e5);
  }), v(function (n) {
    return n.setUTCHours(0, 0, 0, 0);
  }, function (n, t) {
    return n.setUTCDate(n.getUTCDate() + t);
  }, function (n, t) {
    return (t.getTime() - n.getTime()) / 864e5;
  }, function (n) {
    return Math.floor(n.getTime() / 864e5);
  })],
  week: [w, b],
  sunday: [E, S],
  monday: [D, C],
  tuesday: [U, j],
  wednesday: [O, R],
  thursday: [H, V],
  friday: [q, A],
  saturday: [B, F],
  month: [N, z],
  year: [I, P]
},
    gn = Object.keys(hn),
    xn = new RegExp("^every\\s*(\\d+)?\\s*(" + gn.join("|") + ")s?$", "i"),
    kn = function kn(n, t) {
  if (Array.isArray(t)) return t;

  if ("string" == typeof t && "useUTC" in n) {
    var r = t.match(xn);

    if (r) {
      var e = r[1],
          a = r[2],
          i = hn[a][n.useUTC ? 1 : 0];

      if ("day" === a) {
        var o,
            u,
            c = n.domain(),
            f = c[0],
            d = c[1],
            s = new Date(d);
        return s.setDate(s.getDate() + 1), null != (o = null == (u = i.every(Number(null != e ? e : 1))) ? void 0 : u.range(f, s)) ? o : [];
      }

      if (void 0 === e) return n.ticks(i);
      var l = i.every(Number(e));
      if (l) return n.ticks(l);
    }

    throw new Error("Invalid tickValues: " + t);
  }

  if ("ticks" in n) {
    if (void 0 === t) return n.ticks();
    if ("number" == typeof (m = t) && isFinite(m) && Math.floor(m) === m) return n.ticks(t);
  }

  var m;
  return n.domain();
};

export { nn as castBandScale, X as castLinearScale, Z as castPointScale, pn as centerScale, un as compareDateValues, on as compareValues, cn as computeScale, dn as computeXYScalesForSeries, _ as createBandScale, Q as createDateNormalizer, W as createLinearScale, rn as createLogScale, Y as createPointScale, L as createPrecisionMethod, en as createSymlogScale, tn as createTimeScale, ln as generateSeriesAxis, sn as generateSeriesXY, an as getOtherAxis, kn as getScaleTicks, J as precisionCutOffs, K as precisionCutOffsByType, mn as stackAxis, G as timePrecisions };